import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import ListagemHeader from '../../../components/gww-lib/listagens-header/index';
import NavBar from '../../../components/layout/navbar/index';


function ListaGrupoImposto({ history }) {

    function vaiGrupoImposto(registroUnico) {
        history.push('/cadastro-grupo-imposto', { registroUnico });
    }

    const columns = {
        dic: [
            { id: 'CCDTAXGRUPO', label: 'Código', minWidth: 10 },
            { id: 'CDSTAXGRUPO', label: 'Descrição', minWidth: 10 },         
        ]
    };

    let filtrosGrupoImposto = {
        dic: [
            {
                campoFiltro: "CDSTAXGRUPO",
                descricaoFiltro: "Descrição",
            },
        ],
    };



    return (
        <Fragment>
            <NavBar />
            <ListagemHeader
                filtros={filtrosGrupoImposto}
                columns={columns}
                tela="ListaGrupoImposto"
                titulo="Grupo de Imposto"
                nomeChave="PCCDTAXGRUPO"
                metodoListagem="WEBSITE_LISTAGEM_IMP_GRUPO"
                metodoConsultaUnica="WEBSITE_TIMPOSTO_GRUPO_BYID"
                vaiPara={(registro) => vaiGrupoImposto(registro)}
            />
        </Fragment>
    )
}

export default withRouter(ListaGrupoImposto);